import axios from '@axios'

export default {
  namespaced: true,
  state: {
    price_file_rg: null,
    price_file_ig: null,

    // Цены по объектам из прайс-листа клиента (09.10.2026): null — ещё не
    // спрашивали, { groups: [] } — прайс для клиента не заполнен.
    table: null,
    request_is_success: null,
    request_error_msg: null,
  },
  getters: {
    getPriceFileRG: state => state.price_file_rg,
    getPriceFileIG: state => state.price_file_ig,
    getTable: state => state.table,
    getRequestStatus: state => state.request_is_success,
    getRequestErrorMsg: state => state.request_error_msg,
  },
  mutations: {
    set_on_request_success(state, payload) {
      // У клиента без файлов (и на стенде) список пуст — страница не должна падать.
      const first = (payload && payload[0]) || {}
      state.price_file_rg = first.file_rg || null
      state.price_file_ig = first.file_ig || null
      state.request_is_success = true
      state.request_error_msg = null
    },
    set_table(state, payload) {
      state.table = payload
    },
    set_on_request_error(state, error) {
      state.price_file_rg = null
      state.price_file_ig = null
      state.request_is_success = false
      state.request_error_msg = error
    },
  },
  actions: {
    getPricelists({ commit }) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/api/v1/pricelist/',
        })
          .then(response => {
            if (response.status === 200) {
              commit('set_on_request_success', response.data)
              resolve(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchTable({ commit }) {
      return axios({
        method: 'get',
        url: '/api/v1/pricelist/table/',
      })
        .then(response => {
          commit('set_table', (response.data && response.data.data) || { groups: [] })
        })
        .catch(() => {
          commit('set_table', { groups: [] })
        })
    },
  },
}
